// extracted by mini-css-extract-plugin
export default {"imageWrapper":"EF-z","hovered":"FF-z","hoverImage":"GF-z","mainImage":"HF-z","imageNoBackground":"IF-z","fullSizeImage":"JF-z"};